// src/types.ts
var FetchMethod = /* @__PURE__ */ ((FetchMethod2) => {
  FetchMethod2["GET"] = "GET";
  FetchMethod2["POST"] = "POST";
  FetchMethod2["PUT"] = "PUT";
  FetchMethod2["DELETE"] = "DELETE";
  FetchMethod2["PATCH"] = "PATCH";
  return FetchMethod2;
})(FetchMethod || {});
var ResponseStatus = /* @__PURE__ */ ((ResponseStatus2) => {
  ResponseStatus2["SUCCESS"] = "success";
  ResponseStatus2["ERROR"] = "error";
  ResponseStatus2["ABORTED"] = "aborted";
  return ResponseStatus2;
})(ResponseStatus || {});

// src/dvrdFetch.ts
var DefaultFetch = class {
  _baseURL;
  _credentials;
  _headers;
  _cache;
  constructor(options) {
    this._baseURL = options?.baseURL;
    this._credentials = options?.credentials;
    this._headers = options?.headers;
    this._cache = options?.cache;
  }
  get(config) {
    return sendRequest({
      baseURL: this._baseURL,
      credentials: this._credentials,
      headers: this.mergedHeaders(config),
      cache: this._cache,
      ...config,
      method: "GET" /* GET */
    });
  }
  post(config) {
    return sendRequest({
      baseURL: this._baseURL,
      credentials: this._credentials,
      headers: this.mergedHeaders(config),
      cache: this._cache,
      ...config,
      method: "POST" /* POST */
    });
  }
  put(config) {
    return sendRequest({
      baseURL: this._baseURL,
      credentials: this._credentials,
      headers: this.mergedHeaders(config),
      cache: this._cache,
      ...config,
      method: "PUT" /* PUT */
    });
  }
  delete(config) {
    return sendRequest({
      baseURL: this._baseURL,
      credentials: this._credentials,
      headers: this.mergedHeaders(config),
      cache: this._cache,
      ...config,
      method: "DELETE" /* DELETE */
    });
  }
  patch(config) {
    return sendRequest({
      baseURL: this._baseURL,
      credentials: this._credentials,
      headers: this.mergedHeaders(config),
      cache: this._cache,
      ...config,
      method: "PATCH" /* PATCH */
    });
  }
  get baseURL() {
    return this._baseURL;
  }
  set baseURL(value) {
    this._baseURL = value;
  }
  get credentials() {
    return this._credentials;
  }
  set credentials(value) {
    this._credentials = value;
  }
  get headers() {
    return this._headers;
  }
  set headers(value) {
    this._headers = value;
  }
  get cache() {
    return this._cache;
  }
  set cache(value) {
    this._cache = value;
  }
  mergedHeaders(config) {
    if (!config.headers)
      return this._headers;
    if (!this._headers)
      return config.headers;
    return { ...this._headers, ...config.headers };
  }
};
function sendRequest(config) {
  config.method = config.method ?? "GET" /* GET */;
  if (["POST" /* POST */, "PUT" /* PUT */].includes(config.method) && !config.data)
    throw new Error("Cannot POST or PUT without data");
  else if (["GET" /* GET */, "DELETE" /* DELETE */].includes(config.method) && !!config.data)
    throw new Error("Cannot GET or DELETE with data");
  const requestConfig = buildRequestOptions(config);
  const abortController = new AbortController();
  requestConfig.signal = abortController.signal;
  fetch((config.baseURL ?? "") + buildURL(config), requestConfig).then(
    (response) => {
      if (config.callback)
        handleResponse(response, config.callback);
    }
  ).catch((error) => {
    if (error instanceof DOMException) {
      if (error.name === "AbortError")
        config.callback?.({ status: "aborted" /* ABORTED */ }, null);
      else
        config.callback?.({ status: "error" /* ERROR */, message: `Request error: ${error.message}` }, null);
    } else {
      config.callback?.({
        status: "error" /* ERROR */,
        message: `Application error: ${error.message}`,
        error
      }, null);
    }
  });
  return abortController;
}
function buildURL(config) {
  const { url } = config;
  if (typeof url === "string")
    return url;
  return createParamUrl(url.url, url);
}
function createParamUrl(url, params) {
  for (const [key, value] of Object.entries(params)) {
    if (key === "url")
      continue;
    if (value?.toString().length)
      url = url.replace(`{${key}}`, value.toString());
    else
      url = url.replace(`{${key}}`, "");
    if (url.endsWith("/"))
      url = url.substring(0, url.length - 1);
  }
  return url;
}
function buildRequestOptions(config) {
  if (config.data && !(config.data instanceof FormData))
    config.data = JSON.stringify(config.data);
  return {
    method: config.method ?? "GET" /* GET */,
    body: config.data,
    credentials: config.credentials
  };
}
function handleResponse(response, callback) {
  const success = response.ok;
  const status = success ? "success" /* SUCCESS */ : "error" /* ERROR */;
  response.text().then((content) => {
    try {
      const json = JSON.parse(content);
      callback({ status, success, ...json }, response);
    } catch {
      callback({ status, success, message: content }, response);
    }
  });
}

// src/index.ts
var src_default = sendRequest;
export {
  DefaultFetch,
  FetchMethod,
  ResponseStatus,
  src_default as default
};
//# sourceMappingURL=index.mjs.map